import React, { Component } from "react";
import cuid from "cuid";
import Card from "./../Card";
import "./index.scss";

class index extends Component {
  createLine = () => {
    const { data, theme, cardBirthday, cardAbsence } = this.props;

    return (
      <div>
        {cardBirthday ? (
          <div className="line">
            {Object.keys(data).map(index => (
              <Card
                name={data[index].name}
                date={data[index].date}
                theme={theme}
                key={cuid()}
                type={"person"}
              />
            ))}
          </div>
        ) : cardAbsence ? (
          <div className="line">
            {Object.keys(data).map(index => (
              <Card
                name={data[index].name}
                vacations={data[index].vacations}
                abscence={data[index].abscence}
                theme={theme}
                key={cuid()}
                id={data[index].id}
                type={"absence"}
              />
            ))}
          </div>
        ) : (
          <div className="line">
            {Object.keys(data).map(index => (
              <Card
                id={index}
                title={data[index].name}
                subTitle={data[index].parent}
                icon={data[index].icone}
                theme={theme}
                key={cuid()}
                type={"compact"}
              />
            ))}
          </div>
        )}
      </div>
    );
  };
  render() {
    return this.createLine();
  }
}

export default index;
